// ─── Timeline Event Categories ──────────────────────────────────────────────
export const TIRE_EVENT_CATEGORIES = [
  'LIFECYCLE',
  // 'TELEMETRY',
  'INSPECTION',
  'ALERT',
  'MAINTENANCE',
] as const;

export type TireEventCategory = (typeof TIRE_EVENT_CATEGORIES)[number];

// ─── Timeline Request ───────────────────────────────────────────────────────
export interface TireTimelineRequest {
  tireSerialNumber?: string;
  assetId?: string;
  position?: string;
  forceSync?: boolean;
  categories?: TireEventCategory[];
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  sortOrder?: 'newest' | 'oldest';
}

// ─── Timeline Response ──────────────────────────────────────────────────────
export interface TireTimelineTelemetry {
  timestamp: string;
  pressure: number;
  temperature: number;
  pressureUnit: string;
  temperatureUnit: string;
}

export interface TireTimelineEventMetadata {
  assetId?: string;
  position?: string;
  odometerAtInstall?: number;
  engineHoursAtInstall?: number;
  [key: string]: any;
}

export interface TireTimelineEvent {
  id: string;
  tireSerialNumber: string;
  customerId: string;
  eventType: string;
  eventCategory: TireEventCategory;
  severity: 'info' | 'warning' | 'error' | 'critical';
  title: string;
  description: string | null;
  eventTimestamp: string;
  referenceTable: string;
  referenceId: string;
  metadata: TireTimelineEventMetadata;
  createdAt: string;
  updatedAt: string;
  telemetry: TireTimelineTelemetry[];
}

export interface TireTimelineResponse {
  rows: TireTimelineEvent[];
  count: number;
}

// ─── Tire Recommendation (AI Prediction) ────────────────────────────────────
export interface TireRecommendationResponse {
  asset_id: string;
  tire_position: string;
  tire_code: string;
  analysis_date: string;
  date_range: {
    start: string;
    end: string;
  };
  recommendation: {
    health_score: number;
    health_grade: string;
    tread_assessment: {
      current_depth_mm: number;
      status: string;
      wear_rate_mm_per_month: number;
      estimated_months_remaining: number;
      projected_replacement_date: string;
      wear_pattern: string;
      action: string;
    };
    pressure_assessment: {
      current_kpa: number;
      status: string;
      trend: string;
      out_of_range_pct_last_month: number;
      action: string;
    };
    leakage_assessment: {
      total_events: number;
      active_leaks: number;
      risk_level: string;
      pattern: string;
      action: string;
    };
    overall_recommendation: string;
    replace_by_date: string | null;
  };
}
